import { joinGroup } from "firebase-config";
import { buildPickemGroupPath, pickemPath } from "pages/PageConfigs";
import { useState } from "react";
import { useNavigate } from "react-router";
import { SecondaryButton } from "styles/elements";
import { CenterFlexRow } from "styles/layout";
import { ErrorText, SuccessText } from "styles/text";

import {
  FormContainer,
  FormTable,
  InProgressSpinner,
  Input,
  JoinGroupButton,
} from "./styles";

const GROUP_ID_LENGTH = 6;

export const PickemJoinGroupForm = () => {
  const navigate = useNavigate();
  const [groupId, setGroupId] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [controlsDisabled, setControlsDisabled] = useState<boolean>(false);

  const canJoinGroup = () => {
    return groupId.length === GROUP_ID_LENGTH;
  };

  const onClickJoinGroup = async () => {
    setControlsDisabled(true);
    setErrorMessage("");
    setSuccessMessage("");
    await new Promise((r) => setTimeout(r, 2000));
    joinGroup({ groupId: groupId.toLowerCase() })
      .then((result) => {
        const data: any = result.data;
        const message = data?.message ?? "";
        setSuccessMessage(message);
        navigate(buildPickemGroupPath(groupId));
      })
      .catch((error) => {
        setErrorMessage(error.message);
      })
      .finally(() => {
        setControlsDisabled(false);
      });
  };

  const toPickem = () => {
    navigate(pickemPath);
  };

  return (
    <FormContainer>
      <FormTable>
        <tbody>
          <tr>
            <th>Group Id</th>
            <td>
              <Input
                type="text"
                maxLength={6}
                value={groupId}
                onChange={(e) => {
                  setGroupId(e.target.value);
                  setErrorMessage("");
                  setSuccessMessage("");
                }}
              />
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <CenterFlexRow>
                <JoinGroupButton
                  onClick={onClickJoinGroup}
                  disabled={controlsDisabled || !canJoinGroup()}
                >
                  {controlsDisabled ? <InProgressSpinner /> : "Join Group"}
                </JoinGroupButton>
              </CenterFlexRow>
            </td>
          </tr>
        </tbody>
      </FormTable>
      <ErrorText>{errorMessage}</ErrorText>
      <SuccessText>{successMessage}</SuccessText>
      <SecondaryButton style={{ marginTop: "10px" }} onClick={toPickem}>
        Return To Pick'em
      </SecondaryButton>
    </FormContainer>
  );
};
